import React from 'react';
import parse from 'html-react-parser';
import styles from './heroMobileList.module.scss';

function HeroMobileList({ items = [], onCardClick, mailOfferContent }) {
  if (!items || items.length === 0) {
    return null;
  }

  const handleClick = (item) => {
    if (onCardClick && item.ctaButton?.label) {
      onCardClick(item, item.ctaButton.label);
    }
  };

  const handleKeyDown = (e, item) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick(item);
    }
  };

  return (
    <div className={styles.mobileList}>
      {items.map((item, index) => {
        const imageUrl = item.headlineImage?.fields?.file?.url;

        return (
          <div
            key={item.id || index}
            className={styles.card}
            onClick={() => handleClick(item)}
            onKeyDown={(e) => handleKeyDown(e, item)}
            role="button"
            tabIndex={0}
            aria-label={item.headline}
          >
            {imageUrl && (
              <div
                className={styles.thumbnail}
                style={{ backgroundImage: `url(https:${imageUrl})` }}
              />
            )}

            <div className={styles.content}>
              {item.headline && (
                <h3 className={styles.headline}>{parse(item.headline)}</h3>
              )}
              {item.promotion && (
                <p className={styles.promotion}>{parse(item.promotion)}</p>
              )}
              {item.ctaButton?.label && (
                <span className={styles.ctaLink}>
                  {item.ctaButton.label}
                  <span className={styles.ctaArrow} aria-hidden="true">
                    →
                  </span>
                </span>
              )}
            </div>
          </div>
        );
      })}

      {mailOfferContent && (
        <div className={styles.mailOfferRow}>{mailOfferContent}</div>
      )}
    </div>
  );
}

export default HeroMobileList;
